export const getAnalyticsUserType = (isBuyer: boolean) => (isBuyer ? 'Buyer' : 'Seller');
